import { useEffect, useState } from "react";

// 앱 전역에서 쓰는 모바일 브레이크포인트(768px)와 동일하게 맞춤 (App.js AppShell 기준).
export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}
